import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/components/auth/AuthProvider";
import { CircleBooking, CircleEvent } from "@/types/circle";

export type MyCircleBooking = CircleBooking & {
  circle_event: CircleEvent;
};

export function useMyCircleBookings() {
  const { userId } = useAuth();

  const { data: bookings, isLoading, error } = useQuery({
    queryKey: ["my-circle-bookings", userId],
    queryFn: async () => {
      if (!userId) return [];

      const { data, error } = await supabase
        .from("circle_bookings")
        .select(`
          *,
          circle_event:circle_events!circle_bookings_circle_event_id_fkey(
            *,
            host:profiles!circle_events_host_id_fkey(
              id,
              first_name,
              last_name,
              avatar_url
            )
          )
        `)
        .eq("user_id", userId)
        .eq("status", "confirmed")
        .order("booked_at", { ascending: false });

      if (error) throw error;

      return data as MyCircleBooking[];
    },
    enabled: !!userId,
  });

  // Separate into upcoming and past
  const now = new Date().toISOString();
  const upcomingBookings = bookings?.filter(b => b.circle_event.end_time > now) || [];
  const pastBookings = bookings?.filter(b => b.circle_event.end_time <= now) || [];

  return {
    bookings: bookings || [],
    upcomingBookings,
    pastBookings,
    isLoading,
    error,
  };
}
